<template>
   <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark color="primary" dense>
  <v-toolbar-title class="text-body-1">
    {{ collectionType === 1 ? 'eBooks' : 'Journals' }}
  </v-toolbar-title>
</v-toolbar>
      <v-card-text>
        <v-divider></v-divider>
        <div class="row">
          <div class="col">
            <v-simple-table>
  <template v-slot:default>
    <thead>
      <tr>
        <th style="width:500px" class="text-left">Title</th>
        <th style="width:200px" class="text-left">Publisher Name</th>
        <th style="width: 200px">{{ collectionType === 1 ? 'ISBN' : 'ISSN' }}</th>
        <th class="text-left" v-if="collectionType === 1">Contributor</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in list" :key="item.id">
        <td>{{ item.Title }}</td>
        <td>{{ item.PublisherName || item.Publisher }}</td>
        <td>{{ collectionType === 1 ? item.ISBN : item.ISSN }}</td>
        <td v-if="collectionType === 1">{{ item.contributor1 }}</td>
      </tr>
    </tbody>
  </template>
</v-simple-table>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancel" v-if="!options.noconfirm"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  name: 'PublicationList',
  computed: {
  },
  created() {
    
  },
  methods: {
    open(list, collectionType = 1) {
    this.dialog = true;
    this.list = list;
    this.collectionType = collectionType;
  },
  cancel() {
    this.dialog = false;
    this.list = [];
    this.collectionType = 1;
  },
  },
  props: {
  },
  computed: {
  },
  watch: {
    notify() {
    },
  },
  data() {
    return {
      list: [],
      dialog: false,
      collectionType: 1,
      options: {
        color: "primary",
        width: 1200,
        zIndex: 200,
        noconfirm: false,
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/PublicationList.vue